import { c as _c } from "react/compiler-runtime";
import { strikeWeightKeyPointsByLevel } from '@/lib/piano/touch-design/data/strike-weight';
import { StrikeWeightLevel } from '@/lib/piano/touch-design/hammer-weight-level';
import { useCallback, useMemo } from 'react';
import { useInterpolatedSerieCubicSpline } from '../series/use-interpolated-serie-cubic-spline';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
export const useStrikeWeightCurve = keyboard => {
  const $ = _c(8);
  const {
    generateCubicInterpolatedKeyboardSerie,
    interpolateStandardKeypointsToKeyboardSize
  } = useInterpolatedSerieCubicSpline(keyboard);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.values(StrikeWeightLevel);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== generateCubicInterpolatedKeyboardSerie || $[2] !== interpolateStandardKeypointsToKeyboardSize) {
    t1 = new Map(t0.map(level => [level, generateCubicInterpolatedKeyboardSerie(interpolateStandardKeypointsToKeyboardSize(strikeWeightKeyPointsByLevel[level]))]));
    $[1] = generateCubicInterpolatedKeyboardSerie;
    $[2] = interpolateStandardKeypointsToKeyboardSize;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const smoothedStrikeWeightCurves = t1;
  let t2;
  if ($[4] !== smoothedStrikeWeightCurves) {
    t2 = level_0 => smoothedStrikeWeightCurves.get(level_0);
    $[4] = smoothedStrikeWeightCurves;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getStrikeWeightCurve = t2;
  let t3;
  if ($[6] !== getStrikeWeightCurve) {
    t3 = {
      getStrikeWeightCurve
    };
    $[6] = getStrikeWeightCurve;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};